const emailValidate = (email) =>
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
		email.toLowerCase()
	);

const phoneValidate = (phone = "") => {
    const digits = phone.replace(/\D/g, "");
    if (!digits) return false;

    // Permite +57 / 57 y normaliza a 10 dígitos nacionales
    let national = digits;
    if (digits.length === 12 && digits.startsWith("57")) {
        national = digits.slice(2);
    }

    // Celular colombiano: 10 dígitos iniciando en 3
    if (!/^3\d{9}$/.test(national)) return false;

    // Evita números "extraños" como 0000000000, 1111111111, etc.
    if (/^(\d)\1{9}$/.test(national)) return false;

    return true;
};

const nitValidate = (nit) => /^\d{5,12}-?\d?$/.test(nit);

const plateValidate = (plate) => {
	const carPlateRegex = /^[A-Z]{3}\d{3}$/;
	const motorcyclePlateRegex = /^[A-Z]{3}\d{2}[A-Z]{1}$/;
	return carPlateRegex.test(plate) || motorcyclePlateRegex.test(plate);
};

const serialValidate = (serial) => serial.match(/^\d{4}[I]\d{6}$/);

const cedulaValidate = (id) => id.replace(/[^\d]/g, "").length <= 6;

const textValidate = (text) => {
	if (text.length < 5) return false;
	if (text.length > 60) return false;
	return true;
};

export {
	nitValidate,
	emailValidate,
	phoneValidate,
	plateValidate,
	serialValidate,
	cedulaValidate,
	textValidate,
};
